import React, { memo } from 'react';
import Slider from '@theme/js/components/common/Slider';

import * as Types from './types';
import { GamesRow } from '@core/js/components/main/GamesGrid/components/GamesRow';
import { SLIDER_OPTIONS } from '@core/js/components/main/GamesGrid/components/GamesSliderView/constants';
import { GamesHeader } from '@core/js/components/main/GamesGrid/components/GamesHeader';

import style from './GamesSliderView.scss';

export const GamesSliderViewBare: React.FC<Types.IGamesSliderViewProps> = ({
    tileGap,
    feedName,
    categoryName,
    allGamesCount,
    categoryRowsCount,
    isSliderArrowsShown,
    categoryLayoutWithGames,
    rows
}) => {
    return (
        <>
            <GamesHeader
                feedName={feedName}
                categoryName={categoryName}
                allGamesCount={allGamesCount}
                categoryRowsCount={categoryRowsCount}
                categoryLayoutWithGames={categoryLayoutWithGames}
            />
            <Slider
                options={{
                    ...SLIDER_OPTIONS,
                    ...tileGap ? { slideGap: Number(tileGap) } : {}
                }}
                isAllItemsVisible
                showDisabledArrows
                autoRotate={false}
                showControlsAtStart={true}
                showControls={isSliderArrowsShown}
                className={`${style.slider} cms-games-grid-category-slider rows-${rows}`} // Lugano changes
                classNames={{
                    leftArrow: style.leftArrow,
                    rightArrow: style.rightArrow,
                    sliderContainer: style.sliderContainer
                }}
            >
                {categoryLayoutWithGames.map((games, index) => {
                    if (categoryRowsCount && categoryRowsCount < index + 1) {
                        return null;
                    }

                    return (
                        <GamesRow
                            key={index}
                            tabIndex={0}
                            games={games}
                            categoryName={categoryName}
                        />
                    );
                }).filter(Boolean)}
            </Slider>
        </>
    );
};

export const GamesSliderView = memo(GamesSliderViewBare);
